import { render, staticRenderFns } from "./TaxiVehicleModal.vue?vue&type=template&id=523d97cd"
import script from "./TaxiVehicleModal.vue?vue&type=script&lang=js"
export * from "./TaxiVehicleModal.vue?vue&type=script&lang=js"
import style0 from "./TaxiVehicleModal.vue?vue&type=style&index=0&id=523d97cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports